import { CurrenciesCrypto } from '@sparling/financial-common'

interface ITransformation {
  x: number
  y: number
}

type Transformation = {
  [currencies: string]: ITransformation
}

const transformation: Transformation = {
  [`${CurrenciesCrypto.BTC}`]: {
    x: 10,
    y: 8,
  },
  [`${CurrenciesCrypto.ETH}`]: {
    x: 10,
    y: 18,
  },
}

export const formatCurrency = (amount: number, currency: string): number => {
  const tCurrency: ITransformation = transformation[currency]
  // eslint-disable-next-line no-param-reassign,no-restricted-properties,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-restricted-properties
  return Math.trunc(amount * Math.pow(tCurrency.x, tCurrency.y))
}

// TODO: Expand symbols for more cryptocurrencies or use a third-party package.
const cryptoSymbols: Record<string, string> = {
  BTC: '₿',
  ETH: 'Ξ',
  USDT: '₮',
}

export const formatCryptoCurrency = (value: number, code: string, decimals = 8): string => {
  const symbol = cryptoSymbols[code] || code
  return `${symbol} ${new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals,
  }).format(value)}`
}
